import React from 'react';
import { motion } from 'framer-motion';
import { HiBadgeCheck, HiAcademicCap } from 'react-icons/hi';

const certifications = [
  { title: 'Cyber Security Essentials', year: '2024', icon: <HiBadgeCheck /> },
  { title: 'Phishing Awareness', year: '2024', icon: <HiBadgeCheck /> },
  { title: 'Women\'s Leadership Development', year: '2019', icon: <HiAcademicCap /> },
  { title: 'Full Stack Web Development', year: '2020', organization: 'Code to Inspire', icon: <HiAcademicCap /> },
];

const Certifications = () => {
  return (
    <section id="certifications" className="py-12 sm:py-16 md:py-20 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 right-1/4 w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 bg-beige-400 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 relative z-10">
        {/* Section Header */}
        <motion.div
          className="text-center mb-10 sm:mb-12 md:mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-beige-600 font-semibold text-xs sm:text-sm uppercase tracking-wider">
            Credentials
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-900 mt-2 font-primary">
            Certifications & Awards
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-beige-500 mx-auto mt-3 sm:mt-4"></div>
          <p className="mt-4 sm:mt-6 text-gray-600 max-w-2xl mx-auto text-sm sm:text-base px-4">
            Verified credentials that demonstrate my commitment to excellence and ongoing professional development.
          </p>
        </motion.div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto">
          {certifications.map((cert, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gradient-to-br from-beige-50 to-white p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-lg border border-beige-200 hover:shadow-xl hover:border-beige-400 transition-all duration-300 group text-center"
            >
              <div className="text-beige-600 text-3xl sm:text-4xl mb-3 sm:mb-4 flex justify-center group-hover:text-beige-700 transition-colors">
                {cert.icon}
              </div>
              <h3 className="text-base sm:text-lg font-bold text-navy-900 mb-2 font-primary">
                {cert.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600">{cert.year}</p>
              {cert.organization && (
                <p className="text-xs text-beige-700 mt-2">{cert.organization}</p>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
